import { type ToastOptions, ToastProvider } from '@carvana/showroom-toast';
import { useContext, useEffect } from 'react';
import ErrorContext from '~/context/srp/ErrorContext';

type OwnProps = {
  showToast: (opt: ToastOptions) => void;
};

function NativeError({ showToast }: OwnProps) {
  const { nativeError } = useContext(ErrorContext);

  useEffect(() => {
    if (!nativeError) return;

    showToast({
      body: nativeError.message,
      className: 'native-error-toast',
      label: 'Error',
      lifetime: 0,
      severity: 'error'
    });
  }, [nativeError, showToast]);

  return null;
}

export default () => (
  <ToastProvider
    render={({ showToast }) => <NativeError showToast={showToast} />}
  />
);
